<template>
  <div>
    <div class="fast-modal-content">
      <Teleport to="#fast-title">Saisissez votre prénom et votre nom</Teleport>

      <div class="row">
        <StepRegistrationInput
          :grid-class="'col-12 col-sm-6'"
          :label="'Prénom'"
          :value="firstName"
          autofocus
          name="first_name"
          autocomplete="given-name"
          @attributeChange="handleAttributeChange('firstName', $event)"
        />
        <StepRegistrationInput
          :grid-class="'col-12 col-sm-6'"
          :label="'Nom'"
          :value="lastName"
          name="last_name"
          autocomplete="family-name"
          @attributeChange="handleAttributeChange('lastName', $event)"
        />
      </div>
    </div>
    <StepsNavigation :next-step-disabled="!isValid" @prevStep="handlePrevStep" @nextStep="handleNextStep" />
  </div>
</template>

<script>
import stepEvents from '../mixins/stepEvents'
import StepRegistrationInput from './StepRegistrationInput.vue'
import StepsNavigation from './StepsNavigation.vue'

export default {
  name: 'StepRegistration',
  components: {
    StepRegistrationInput,
    StepsNavigation
  },
  mixins: [stepEvents],
  props: {
    firstName: {
      type: String,
      required: true
    },
    lastName: {
      type: String,
      required: true
    }
  },
  computed: {
    isValid() {
      return (
        this.firstName.length > 0 && this.firstName.length <= 50 && this.lastName.length > 0 && this.lastName.length <= 50
      )
    }
  },
  methods: {
    handleAttributeChange(param, value) {
      this.$emit('attributeChange', param, value)
    }
  }
}
</script>
